import React from 'react'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/styles'
import PermContactCalendarOutlinedIcon from 'components/material-symbol/icons/PermContactCalendar'
import EnhancedTable from 'components/tables/enhanced-table'
import SectionEmptyState from 'components/section-empty-state'
import { LeadTableItem } from './lead-table-item'
import { useIsTablet } from 'lib/hooks'

const useStyles = makeStyles(theme => ({
  listEmptyStateContent: {
    padding: theme.spacing(4, 2),
  },
}))

const ContactedLeads = ({
  contactedLeads,
  refetch,
  sortByFullName,
  sortByCreatedOn,
  page,
  onPageChange,
  rowsPerPage = 25,
}) => {
  const classes = useStyles()
  const isTablet = useIsTablet()

  return (
    <EnhancedTable
      rows={contactedLeads.map(lead => (
        <LeadTableItem
          lead={lead}
          key={lead.id}
          refetch={refetch}
          showRelativeTime
        />
      ))}
      columns={[
        {
          id: 'name',
          label: 'Name',
          align: 'left',
          width: isTablet ? '80%' : '30%',
          mobile: true,
          sortable: true,
          sortComparator: sortByFullName,
        },
        {
          id: 'submitted',
          label: 'Submitted',
          align: 'left',
          width: '20%',
          mobile: false,
          sortable: true,
          sortComparator: sortByCreatedOn,
        },
        {
          id: 'interest',
          label: 'Interest',
          align: 'left',
          width: '30%',
          mobile: false,
          sortable: false,
        },
        {
          id: 'actions',
          label: '',
          align: 'right',
          width: '10%',
          mobile: true,
          sortable: false,
        },
      ]}
      label="Contacted Leads"
      numberOfRows={rowsPerPage}
      variant="list"
      rowHeight="56px"
      page={page}
      onPageChange={onPageChange}
      showHeaderPagination={false}
      showPaginator={false}
      emptyState={() => (
        <Box className={classes.listEmptyStateContent}>
          <SectionEmptyState
            Icon={PermContactCalendarOutlinedIcon}
            title="Leads"
            caption="No contacted leads."
            bordered={false}
          />
        </Box>
      )}
    />
  )
}

export default ContactedLeads
